import { render, staticRenderFns } from "./WebsiteMetadata.vue?vue&type=template&id=09037c78"
import script from "./WebsiteMetadata.vue?vue&type=script&lang=js"
export * from "./WebsiteMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports